import { createPersistedOptimisticOverlay } from '@/util/persistedOptimisticOverlay'
import type { TrackLikesContext } from '@amzn/amp-playback'

// Leaf (see persistedOptimisticOverlay) so the boot-eager reapply doesn't drag
// trackLikeService's mutation + toggle machinery onto the entry chunk.
export const trackLikeOverlay = createPersistedOptimisticOverlay<boolean>({
    persistenceKey: 'overlay:trackLike',
    validateValue: (v): v is boolean => typeof v === 'boolean',
    buildEntity: (trackId, liked): TrackLikesContext => ({
        __typename: 'Track',
        id: trackId,
        likesContext: { liked },
    }),
})

/** Re-arm the normalized cache from persisted track likes on boot. */
export const reapplyPersistedTrackLikes = trackLikeOverlay.reapplyPersisted
